import {AlertsActions} from "./alertsActions.enum"

export const setErrorAlert = (message: string) => {
    return {
        type: AlertsActions.SET_ERROR_ALERT,
        payload: message
    }
}

export const setSuccessAlert = (message: string) => {
    return {
        type: AlertsActions.SET_SUCCES_ALERT,
        payload: message
    }
}

export const setListMessage = (message: string) => {
    return {
        type: AlertsActions.SET_LIST_MESSAGE,
        payload: message
    }
}

export const setDialogError = (message: string) => {
    return{
        type: AlertsActions.SET_DIALOG_ERROR,
        payload: { message, title: "Brakuje danych" }
    }
}

export const setDialogApiError = (message: string) => {
    return{
        type: AlertsActions.SET_DIALOG_ERROR,
        payload: { message, title: "Błąd" }
    }
}

export const clearAlerts = () => {
    return{
        type: AlertsActions.CLEAR_ALERTS
    }
}

export const clearListMessages = () => {
    return{
        type: AlertsActions.CLEAR_LIST_MESSAGES
    }
}

export const setListErr = (message: string) => {
    return {
        type: AlertsActions.SET_LIST_ERR,
        payload: message
    }
}